import { ICurrency } from 'meta/currency'
import { useAppSelector } from 'store'
import { CurrencySelectors } from 'store/currency'

export const useActiveCurrency = (): ICurrency => useAppSelector(CurrencySelectors.getCurrency())
